/* cybul specimens — odtwarzacz, fale, ASCII, skróty, koszyk. Bez bibliotek. */
(() => {
  'use strict';
  const C = window.cybul || {};
  const P = C.player || { autonext: true, realWave: true, volume: 0.8 };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const css = (name) => getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  const fmt = (s) => { if (!isFinite(s) || s < 0) s = 0; const m = Math.floor(s / 60); return m + ':' + String(Math.floor(s % 60)).padStart(2, '0'); };
  const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"'));

  /* ---------- fale ---------- */
  const peaksCache = new Map();
  function hash(str) { let h = 2166136261; for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function seeded(src, n = 220) {
    if (peaksCache.has(src)) return peaksCache.get(src);
    let a = hash(src || 'cybul');
    const rnd = () => { a |= 0; a = (a + 0x6D2B79F5) | 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
    const sections = 4 + Math.floor(rnd() * 4);
    const levels = Array.from({ length: sections }, () => 0.45 + rnd() * 0.55);
    const out = [];
    for (let i = 0; i < n; i++) {
      const x = i / n, sec = Math.min(sections - 1, Math.floor(x * sections));
      const intro = Math.min(1, x * 9), outro = Math.min(1, (1 - x) * 14);
      const kick = (i % 8 === 0 ? 0.25 : 0) + (i % 4 === 0 ? 0.1 : 0);
      out.push(Math.max(0.06, Math.min(1, levels[sec] * (0.55 + rnd() * 0.45 + kick) * intro * outro)));
    }
    return out; // nie zapisujemy w cache, żeby prawdziwa fala mogła nadpisać
  }
  async function realPeaks(src, n = 220) {
    if (!P.realWave || !src || peaksCache.has(src)) return peaksCache.get(src);
    try {
      const res = await fetch(src, { mode: 'cors' });
      if (!res.ok) return null;
      const buf = await res.arrayBuffer();
      const AC = window.OfflineAudioContext || window.webkitOfflineAudioContext;
      const ctx = new AC(1, 44100, 44100);
      const audio = await ctx.decodeAudioData(buf);
      const data = audio.getChannelData(0), step = Math.floor(data.length / n) || 1, out = [];
      let max = 0;
      for (let i = 0; i < n; i++) { let peak = 0; for (let j = i * step, e = Math.min(data.length, j + step); j < e; j += 16) { const v = Math.abs(data[j]); if (v > peak) peak = v; } out.push(peak); if (peak > max) max = peak; }
      const norm = out.map((v) => Math.max(0.05, max ? v / max : 0));
      peaksCache.set(src, norm);
      return norm;
    } catch (e) { return null; }
  }
  function drawWave(cv, progress = 0) {
    const src = cv.dataset.wave || cv.dataset.src || '';
    const w = cv.clientWidth, h = cv.clientHeight;
    if (!w || !h) return;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) { cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); }
    const g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);
    const peaks = peaksCache.get(src) || seeded(src);
    const bw = h > 50 ? 2 : 1.5, gap = h > 50 ? 2 : 1.5, n = Math.max(8, Math.floor(w / (bw + gap)));
    const on = css('--paper') || '#E9E7E1', off = css('--ash') || '#8E8D89';
    const cut = progress * n;
    for (let i = 0; i < n; i++) {
      const p = peaks[Math.floor((i / n) * peaks.length)] || 0.1;
      const bh = Math.max(1, p * h * 0.92);
      g.fillStyle = i < cut ? on : off;
      g.globalAlpha = i < cut ? 1 : 0.55;
      g.fillRect(i * (bw + gap), (h - bh) / 2, bw, bh);
    }
    g.globalAlpha = 1;
    if (progress > 0 && progress < 1) { g.fillStyle = on; g.fillRect(Math.floor(progress * w), 0, 1, h); }
  }
  const drawAll = () => $$('canvas[data-wave], canvas[data-p-wave]').forEach((cv) => drawWave(cv, cv === waveP || cv.dataset.wave === (state.item && state.item.src) ? progress() : 0));
  let rto; window.addEventListener('resize', () => { clearTimeout(rto); rto = setTimeout(drawAll, 120); });

  /* ---------- odtwarzacz ---------- */
  const playerEl = $('[data-player]');
  const audio = playerEl ? $('[data-audio]', playerEl) : null;
  const waveP = playerEl ? $('[data-p-wave]', playerEl) : null;
  const state = { item: null, queue: [], index: -1 };
  const KEY = 'cybul:player';
  const progress = () => (audio && audio.duration ? audio.currentTime / audio.duration : 0);

  function itemFrom(el) {
    return { src: el.dataset.src, title: el.dataset.title || '', meta: el.dataset.meta || '', url: el.dataset.url || '', image: el.dataset.image || '', queue: el.dataset.queue || 'q' };
  }
  function buildQueue(q) {
    const seen = new Set(), out = [];
    $$(`[data-play][data-queue="${esc(q)}"], [data-queue-item][data-queue="${esc(q)}"]`).forEach((el) => {
      if (!el.dataset.src || seen.has(el.dataset.src)) return;
      seen.add(el.dataset.src); out.push(itemFrom(el));
    });
    return out;
  }
  function sync() {
    const src = state.item && state.item.src, playing = audio && !audio.paused;
    $$('[data-play]').forEach((b) => { const me = b.dataset.src === src; b.classList.toggle('is-playing', me && playing); b.classList.toggle('is-current', me); });
    $$('[data-row]').forEach((r) => r.classList.toggle('is-current', !!src && r.dataset.src === src));
    const t = $('[data-toggle]', playerEl);
    if (t) t.classList.toggle('is-playing', !!playing);
    playerEl && playerEl.classList.toggle('is-playing', !!playing);
  }
  function showInfo(it) {
    $('[data-p-title]', playerEl).textContent = it.title || '—';
    $('[data-p-meta]', playerEl).textContent = it.meta || '';
    const link = $('[data-p-link]', playerEl); link.href = it.url || '#';
    const cover = $('[data-p-cover]', playerEl); cover.style.backgroundImage = it.image ? `url("${it.image}")` : '';
    waveP.dataset.src = it.src; waveP.dataset.wave = it.src;
    playerEl.hidden = false; document.body.classList.add('has-player');
    requestAnimationFrame(() => drawWave(waveP, progress()));
  }
  function load(it, { autoplay = true, at = 0, queue } = {}) {
    if (!audio || !it || !it.src) return;
    state.item = it;
    state.queue = queue || buildQueue(it.queue);
    if (!state.queue.find((q) => q.src === it.src)) state.queue.unshift(it);
    state.index = state.queue.findIndex((q) => q.src === it.src);
    audio.src = it.src;
    audio.preload = 'auto';
    if (at) { const seekOnce = () => { audio.currentTime = at; audio.removeEventListener('loadedmetadata', seekOnce); }; audio.addEventListener('loadedmetadata', seekOnce); }
    showInfo(it);
    if (autoplay) {
      $$(`[data-play][data-src="${esc(it.src)}"]`).forEach((b) => b.classList.add('is-loading'));
      audio.play().catch(() => { $$('.play.is-loading').forEach((b) => b.classList.remove('is-loading')); sync(); });
    }
    sync();
    realPeaks(it.src).then((p) => { if (p) drawAll(); });
    save();
  }
  function toggle(it) {
    if (!audio) return;
    if (it && (!state.item || state.item.src !== it.src)) return load(it);
    if (!state.item) return;
    audio.paused ? audio.play().catch(() => {}) : audio.pause();
  }
  function step(d) {
    if (!state.queue.length) return;
    const i = state.index + d;
    if (i < 0) { audio.currentTime = 0; return; }
    if (i >= state.queue.length) { audio.pause(); audio.currentTime = 0; return; }
    load(state.queue[i], { queue: state.queue });
  }
  function save() {
    if (!state.item || !audio) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ item: state.item, queue: state.queue.slice(0, 60), t: audio.currentTime || 0, playing: !audio.paused, vol: audio.volume })); } catch (e) {}
  }
  function seekFromEvent(e, el) {
    const r = el.getBoundingClientRect(), x = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    if (audio.duration) audio.currentTime = x * audio.duration;
  }

  if (audio) {
    let vol = P.volume;
    try { const s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (s && typeof s.vol === 'number') vol = s.vol; } catch (e) {}
    audio.volume = vol;
    const volEl = $('[data-vol]', playerEl); if (volEl) { volEl.value = vol; volEl.addEventListener('input', () => { audio.volume = +volEl.value; save(); }); }

    let raf = 0;
    const tick = () => {
      raf = 0;
      const p = progress();
      $('[data-p-time]', playerEl).textContent = `${fmt(audio.currentTime)} / ${fmt(audio.duration)}`;
      drawWave(waveP, p);
      if (state.item) $$(`canvas[data-wave="${esc(state.item.src)}"]`).forEach((cv) => drawWave(cv, p));
    };
    audio.addEventListener('timeupdate', () => { if (!raf) raf = requestAnimationFrame(tick); });
    audio.addEventListener('playing', () => { $$('.play.is-loading').forEach((b) => b.classList.remove('is-loading')); sync(); });
    audio.addEventListener('pause', () => { sync(); save(); });
    audio.addEventListener('play', sync);
    audio.addEventListener('error', () => { $$('.play.is-loading').forEach((b) => b.classList.remove('is-loading')); sync(); });
    audio.addEventListener('ended', () => { sync(); if (P.autonext) step(1); });
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', () => { if (document.hidden) save(); });

    $('[data-toggle]', playerEl).addEventListener('click', () => toggle());
    $('[data-prev]', playerEl).addEventListener('click', () => (audio.currentTime > 3 ? (audio.currentTime = 0) : step(-1)));
    $('[data-next]', playerEl).addEventListener('click', () => step(1));
    $('[data-close]', playerEl).addEventListener('click', () => { audio.pause(); playerEl.hidden = true; document.body.classList.remove('has-player'); state.item = null; sync(); try { sessionStorage.removeItem(KEY); } catch (e) {} });
    $('[data-seek]', playerEl).addEventListener('click', (e) => seekFromEvent(e, e.currentTarget));

    // wznowienie po przejściu na inną stronę
    try {
      const s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      // 20.10: okładka, tytuł i link bierzemy świeże z przycisku na stronie (po zmianie zdjęcia produktu player pokazywał stare)
      if (s && s.item && s.item.src) { const b = $$('[data-play]').find((x) => x.dataset.src === s.item.src); if (b) ['title', 'meta', 'url', 'image'].forEach((k) => { if (b.dataset[k] !== undefined) s.item[k] = b.dataset[k]; }); }
      if (s && s.item && s.item.src) load(s.item, { autoplay: false, at: s.t || 0, queue: s.queue }); // 20.10 Dominik: muzyka nie startuje sama przy wejściu na stronę
    } catch (e) {}
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-play]');
    if (b && b.dataset.src) { e.preventDefault(); toggle(itemFrom(b)); return; }
    const all = e.target.closest('[data-play-all]');
    if (all) { const q = buildQueue(all.dataset.playAll); if (q.length) load(q[0], { queue: q }); return; }
    const sf = e.target.closest('[data-seek-for]');
    if (sf && audio) {
      const src = sf.dataset.seekFor;
      if (!src) return;
      if (!state.item || state.item.src !== src) { const btn = $(`[data-play][data-src="${esc(src)}"]`); if (btn) load(itemFrom(btn)); return; }
      seekFromEvent(e, sf);
    }
  });

  /* ---------- ASCII w hero ---------- */
  const RAMP = ' .:-=+*#%@';
  const GLITCH = '01#@%&$/\\|<>[]{}*+=-:';
  function initAscii(fig) {
    const pre = $('.ascii', fig), mode = fig.dataset.mode;
    if (!pre || mode === 'photo') return;
    const cols = +fig.dataset.cols || 90;
    let rows = 0, grid = [], mouse = null, start = performance.now();
    const fit = () => {
      const w = fig.clientWidth, h = fig.clientHeight;
      const fs = w / (cols * 0.6);
      pre.style.fontSize = fs + 'px';
      rows = Math.max(10, Math.floor(h / fs) - 2);
    };
    const render = (now) => {
      const age = reduce ? 9999 : now - start;
      let out = '';
      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < cols; x++) {
          let ch = grid[y] ? grid[y][x] || ' ' : ' ';
          const reveal = age > 900 || age / 900 > (y / rows) * 0.7 + Math.random() * 0.3;
          if (!reveal) ch = ch === ' ' ? ' ' : GLITCH[(Math.random() * GLITCH.length) | 0];
          if (mouse && ch !== ' ') { const dx = (x - mouse.x) / 1.7, dy = y - mouse.y; if (dx * dx + dy * dy < 22 && Math.random() < 0.55) ch = GLITCH[(Math.random() * GLITCH.length) | 0]; }
          out += ch;
        }
        out += '\n';
      }
      pre.textContent = out;
    };
    const loop = (now) => { render(now); if (now - start < 1000 || mouse) requestAnimationFrame(loop); };
    fig.addEventListener('mousemove', (e) => {
      const r = pre.getBoundingClientRect();
      const was = !!mouse;
      mouse = { x: ((e.clientX - r.left) / r.width) * cols, y: ((e.clientY - r.top) / r.height) * rows };
      if (!was && !reduce) requestAnimationFrame(loop);
    });
    fig.addEventListener('mouseleave', () => { mouse = null; requestAnimationFrame(render); });

    if (mode === 'image') {
      const img = $('.hero__img', fig);
      const fromImage = () => {
        fit();
        try {
          const cv = document.createElement('canvas'); cv.width = cols; cv.height = rows;
          const g = cv.getContext('2d', { willReadFrequently: true });
          const cellAspect = (fig.clientHeight / rows) / (fig.clientWidth / cols);
          const targetRatio = (rows * cellAspect) / cols, imgRatio = img.naturalHeight / img.naturalWidth;
          let sw = img.naturalWidth, sh = img.naturalHeight, sx = 0, sy = 0;
          if (imgRatio > targetRatio) { sh = sw * targetRatio; sy = (img.naturalHeight - sh) / 2; } else { sw = sh / targetRatio; sx = (img.naturalWidth - sw) / 2; }
          g.drawImage(img, sx, sy, sw, sh, 0, 0, cols, rows);
          const d = g.getImageData(0, 0, cols, rows).data;
          let lo = 255, hi = 0; const lum = [];
          for (let i = 0; i < d.length; i += 4) { const l = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; lum.push(l); if (l < lo) lo = l; if (l > hi) hi = l; }
          grid = [];
          for (let y = 0; y < rows; y++) { const row = []; for (let x = 0; x < cols; x++) { const v = (lum[y * cols + x] - lo) / ((hi - lo) || 1); row.push(RAMP[Math.min(RAMP.length - 1, Math.floor(Math.pow(v, 1.15) * RAMP.length))]); } grid.push(row); }
          start = performance.now(); requestAnimationFrame(loop);
        } catch (e) { fig.dataset.mode = 'photo'; }
      };
      if (img.complete && img.naturalWidth) fromImage(); else img.addEventListener('load', fromImage, { once: true });
      img.addEventListener('error', () => { fig.dataset.mode = 'scope'; initScope(); }, { once: true });
      let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fromImage, 200); });
      return;
    }
    initScope();
    function initScope() {
      fit();
      let t0 = performance.now(), visible = true;
      new IntersectionObserver((en) => { visible = en[0].isIntersecting; }).observe(fig);
      const frame = (now) => {
        if (visible) {
          const t = (now - t0) / 1000, playing = audio && !audio.paused, amp = playing ? 0.85 : 0.35;
          grid = [];
          for (let y = 0; y < rows; y++) grid.push(new Array(cols).fill(' '));
          for (let y = 0; y < rows; y += 4) for (let x = 0; x < cols; x += 6) grid[y][x] = '.';
          const mid = rows / 2;
          for (let x = 0; x < cols; x++) {
            const u = x / cols;
            const v = Math.sin(u * 14 + t * 3.1) * 0.5 + Math.sin(u * 37 - t * 5.3) * 0.25 * (playing ? 1.6 : 1) + Math.sin(u * 5 + t * 0.7) * 0.25;
            const yy = Math.round(mid + v * amp * mid * 0.8);
            for (let k = -1; k <= 1; k++) { const yk = yy + k; if (yk >= 0 && yk < rows) grid[yk][x] = k === 0 ? '#' : '+'; }
          }
          const label = playing ? ' ▶ NOW PLAYING ' : ' CH1  2V/DIV  10MS ';
          for (let i = 0; i < label.length && i + 2 < cols; i++) grid[1][i + 2] = label[i];
          render(reduce ? 9999 : now);
        }
        if (!reduce) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    }
  }

  /* ---------- tytuł: dekodowanie liter ---------- */
  function scramble(el) {
    if (reduce) return;
    const final = el.textContent, chars = '#%&@$*+=/<>[]0123456789';
    const t0 = performance.now(), dur = 700;
    const f = (now) => {
      const p = Math.min(1, (now - t0) / dur), n = Math.floor(p * final.length);
      el.textContent = final.slice(0, n) + Array.from(final.slice(n), (c) => (c === ' ' ? ' ' : chars[(Math.random() * chars.length) | 0])).join('');
      if (p < 1) requestAnimationFrame(f); else el.textContent = final;
    };
    requestAnimationFrame(f);
    setTimeout(() => { el.textContent = final; }, dur + 400);
  }

  /* ---------- skróty klawiszowe + invert + zegar ---------- */
  function invert() {
    const on = document.documentElement.classList.toggle('is-invert');
    try { localStorage.setItem('cybul:invert', on ? '1' : '0'); } catch (e) {}
    requestAnimationFrame(drawAll);
  }
  document.addEventListener('keydown', (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (e.code === 'Space' && state.item) { e.preventDefault(); toggle(); return; }
    if (e.key === 'ArrowRight' && state.item && audio.duration) { audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); return; }
    if (e.key === 'ArrowLeft' && state.item) { audio.currentTime = Math.max(0, audio.currentTime - 5); return; }
    const k = (e.key || '').toLowerCase();
    if (k.length !== 1) return;
    const el = $(`[data-key="${esc(k)}"]`);
    if (!el) return;
    e.preventDefault();
    el.classList.add('is-hit'); setTimeout(() => el.classList.remove('is-hit'), 200);
    if (el.hasAttribute('data-invert')) return invert();
    const href = el.getAttribute('href') || '';
    const hash = href.split('#')[1];
    if (hash && document.getElementById(hash)) { document.getElementById(hash).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); return; }
    if (href) location.href = href;
  });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-invert]')) invert(); });

  function clocks() {
    const short = $$('[data-clock]'), full = $$('[data-clock-full]');
    if (!short.length && !full.length) return;
    const tz = { timeZone: 'Europe/Warsaw', hour12: false };
    const upd = () => {
      const d = new Date();
      const time = d.toLocaleTimeString('en-GB', tz), date = d.toLocaleDateString('en-GB', tz).replace(/\//g, '.');
      short.forEach((el) => (el.textContent = 'WAW ' + time));
      full.forEach((el) => (el.textContent = `WAW ${date} ${time}`));
    };
    upd(); setInterval(upd, 1000);
  }

  /* ---------- produkt: miniatury, warianty, długość, koszyk ---------- */
  function initProduct(root) {
    const main = $('.js-main-img', root);
    $$('[data-thumb]', root).forEach((b) => b.addEventListener('click', () => {
      if (main) { main.src = b.dataset.thumb; main.removeAttribute('srcset'); }
      $$('[data-thumb]', root).forEach((x) => x.classList.toggle('is-active', x === b));
    }));
    const form = $('.js-product-form', root);
    if (form) {
      const out = $('[data-price-out]', root), add = $('[data-add]', form);
      const upd = (el) => { const p = el.dataset.price || (el.selectedOptions && el.selectedOptions[0] && el.selectedOptions[0].dataset.price); if (p && out) out.textContent = p; if (add) { add.disabled = false; add.textContent = C.strings.addToCart; } };
      $$('input[name="id"][type="radio"]', form).forEach((r) => r.addEventListener('change', () => upd(r)));
      const sel = $('select[name="id"]', form); if (sel) sel.addEventListener('change', () => upd(sel));
      form.addEventListener('submit', async (e) => {
        if (e.submitter && e.submitter.name !== 'add') return;
        e.preventDefault();
        if (add) add.disabled = true;
        try {
          const res = await fetch(C.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'Error');
          await refreshCount();
          toast(`${C.strings.added} ${json.product_title || ''}`, true);
        } catch (err) { toast(err.message, false); }
        if (add) add.disabled = false;
      });
    }
    $$('[data-duration]', root).forEach((el) => {
      const src = el.dataset.duration; if (!src) return;
      const a = new Audio(); a.preload = 'metadata'; a.src = src;
      a.addEventListener('loadedmetadata', () => (el.textContent = fmt(a.duration)), { once: true });
    });
  }
  async function refreshCount() {
    try { const c = await (await fetch(C.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); $$('[data-cart-count]').forEach((el) => (el.textContent = c.item_count)); } catch (e) {}
  }
  let toastT;
  function toast(msg, withLink) {
    const t = $('[data-toast]'); if (!t) return;
    t.innerHTML = ''; const s = document.createElement('span'); s.textContent = msg; t.appendChild(s);
    if (withLink) { const a = document.createElement('a'); a.href = C.routes.cart; a.textContent = C.strings.viewCart; t.appendChild(a); }
    t.hidden = false; clearTimeout(toastT); toastT = setTimeout(() => (t.hidden = true), 4000);
  }

  /* ---------- kolekcja: sortowanie, filtry, widok ---------- */
  function initCollection(root) {
    const form = $('[data-filters]', root);
    if (form) form.addEventListener('change', () => {
      const p = new URLSearchParams(new FormData(form));
      location.search = p.toString();
    });
    try { const v = localStorage.getItem('cybul:view'); if (v) root.dataset.view = v; } catch (e) {}
    $$('[data-set-view]', root).forEach((b) => b.addEventListener('click', () => {
      root.dataset.view = b.dataset.setView;
      try { localStorage.setItem('cybul:view', b.dataset.setView); } catch (e) {}
      requestAnimationFrame(drawAll);
    }));
  }

  /* ---------- log: zdjęcie za kursorem ---------- */
  function initLog(root) {
    const img = $('[data-log-float]', root); if (!img) return;
    $$('[data-preview]', root).forEach((row) => {
      if (!row.dataset.preview) return;
      row.addEventListener('mouseenter', () => { img.src = row.dataset.preview; img.hidden = false; });
      row.addEventListener('mouseleave', () => (img.hidden = true));
      row.addEventListener('mousemove', (e) => { img.style.left = e.clientX + 'px'; img.style.top = e.clientY + 'px'; });
    });
  }

  /* ---------- polecane ---------- */
  async function initRelated(root) {
    try {
      const html = await (await fetch(root.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related]');
      if (fresh && fresh.innerHTML.trim()) { root.innerHTML = fresh.innerHTML; requestAnimationFrame(drawAll); sync(); }
    } catch (e) {}
  }

  /* ---------- menu mobilne ---------- */
  function initMenu() {
    const btn = $('[data-menu-toggle]'), menu = $('[data-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; btn.setAttribute('aria-expanded', String(open)); });
  }

  /* duży napis = dokładnie szerokość strony (20.10, prodbycybul jest długie) */
  function fit(el) {
    const w = el.clientWidth; if (!w) return;
    el.style.fontSize = ''; const fs0 = parseFloat(getComputedStyle(el).fontSize), sw = el.scrollWidth;
    if (sw) el.style.fontSize = Math.min(300, fs0 * (w * .995) / sw) + 'px';
  }
  const fitAll = () => $$('[data-fit]').forEach(fit);
  window.addEventListener('resize', fitAll);

  function init() {
    $$('[data-ascii]').forEach(initAscii);
    $$('[data-scramble]').forEach(scramble);
    $$('[data-product]').forEach(initProduct);
    $$('[data-collection]').forEach(initCollection);
    $$('[data-log]').forEach(initLog);
    $$('[data-related]').forEach(initRelated);
    initMenu(); clocks();
    drawAll(); sync();
    const big = $('canvas.wave--big[data-wave]');
    if (big && big.dataset.wave) realPeaks(big.dataset.wave).then((p) => p && drawAll());
    fitAll(); setTimeout(fitAll, 1200);
    if (document.fonts) document.fonts.ready.then(() => { drawAll(); fitAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // edytor motywu: odśwież po zmianie sekcji
  document.addEventListener('shopify:section:load', (e) => {
    const r = e.target;
    $$('[data-ascii]', r).forEach(initAscii); $$('[data-scramble]', r).forEach(scramble); $$('[data-fit]', r).forEach(fit);
    $$('[data-product]', r).forEach(initProduct); $$('[data-collection]', r).forEach(initCollection); $$('[data-log]', r).forEach(initLog);
    drawAll(); sync();
  });
})();
